import { render } from "./DosenManajemen.vue?vue&type=template&id=52902372&scoped=true"
import script from "./DosenManajemen.vue?vue&type=script&lang=js"
export * from "./DosenManajemen.vue?vue&type=script&lang=js"

import "./DosenManajemen.vue?vue&type=style&index=0&id=52902372&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52902372"]])

export default __exports__